import { ValidatorService } from './tools/validator.service';
import { ConstantsService } from './constants.service';
import { AutenticacionService } from './autenticacion.service';
import { ErrorsService } from './tools/errors.service';
import { Http, ResponseContentType, URLSearchParams } from '@angular/http';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';


@Injectable()
export class ProductosService {
  
  private service_url: string;
  private serviceFotosUrl: string;

  constructor(private http: Http, 
    private constantsService: ConstantsService, 
    private validatorService: ValidatorService,
    private authService: AutenticacionService, 
    private errorService:ErrorsService) {
    this.service_url = this.constantsService.apiURL + '/productos';
    this.serviceFotosUrl = this.constantsService.apiURL + '/productos/fotos';
  }

  public listarTiposServicios() {
    const options = this.authService.getAuthHeaders();
    let urlServicio = `${this.constantsService.apiURL}/publicos/tipos_servicio`;
    return this.http.get(urlServicio, options);
  }
  
  public listarProductos(filtros: any) {
    let myParams = new URLSearchParams();

    if(filtros.palabra_clave){
      myParams.append('palabra_clave', filtros.palabra_clave);
    }

    if(filtros.id_tipo_servicio){
      myParams.append('id_tipo_servicio', filtros.id_tipo_servicio);
    }

    let options = this.authService.getAuthHeaders();
    options.params = myParams;

    let urlServicio = `${this.constantsService.apiURL}/publicos/productos`;

    return this.http.get(urlServicio, options);
  }

  public listarFotos(filtros: any) {
    const options = this.authService.getAuthHeaders();
    let myParams = new URLSearchParams();

    if(filtros.id_producto){
      myParams.append('id_producto', filtros.id_producto);
    }
    options.params = myParams;

    return this.http.get(`${this.serviceFotosUrl}/listar`, options);
  }

  public subirFoto(id_producto, archivo){
    var data = new FormData();
    data.append('archivo', archivo);

    if(id_producto){
      data.append('id_producto',id_producto);
    }

    return this.http.post(this.serviceFotosUrl, data, this.authService.getAuthHeaders());
  }

  public eliminarFoto(id_producto_foto: number) {
    const options = this.authService.getAuthHeaders();

    return this.http.delete(`${this.serviceFotosUrl}/${id_producto_foto}`, options);
  }

  public obtenerProducto(id_producto: number) {
    let options = this.authService.getAuthHeaders();
    const ulrServicio = `${this.service_url}/${id_producto}`;

    return this.http.get(ulrServicio, options);
  }

  public crear(producto : object) {
    return this.http.post(this.service_url , producto, this.authService.getAuthHeaders());
  }

  public actualizar(producto : object) {
    return this.http.put(this.service_url , producto, this.authService.getAuthHeaders());
  }

  public validar(gasto: any){
    let error = [];

    if(!this.validatorService.required(gasto.nombre)){
        error["nombre"] = this.errorService.required;
    }

    if(!this.validatorService.required(gasto.id_tipo_servicio)){
        error["id_tipo_servicio"] = this.errorService.required;
    }

    if(!this.validatorService.required(gasto.importe_bruto)){
        error["importe_bruto"] = this.errorService.required;
    }

    if(!this.validatorService.required(gasto.sat_product_key)){
        error["sat_product_key"] = this.errorService.required;
    }

    if(!this.validatorService.required(gasto.sat_unidad_key)){
      error["sat_unidad_key"] = this.errorService.required;
  }

    return error;
  }

}


// WEBPACK FOOTER //
// ./src/app/services/productos.service.ts